import { useEffect } from 'react';
import { DEBUG_LAST_BOUNDS } from '~/_shared/constants/debugConstants';
import { MarkerColor } from '../../_shared/types/marker.types';
import { useMapComponentLastBoundsSelector } from '../../store/frontendState/mapComponent/mapComponent.selectors';
import { useMapContext } from './mapContext';

let boundsCounter = 0;

export const useDebugBounds = () => {
  const { webglLayers } = useMapContext();
  const bounds = useMapComponentLastBoundsSelector()?.bounds;

  useEffect(() => {
    if (DEBUG_LAST_BOUNDS && webglLayers && bounds) {
      webglLayers.MapObjectPolygons.add(new WebGLOverlay.Polygon({
        fillColor: Object.values(MarkerColor)[boundsCounter++ % Object.values(MarkerColor).length] as WebglColor,
        opacity: 1,
      }, [[[
        bounds.getNorthEast(),
        { lat: bounds.getNorthEast().lat, lng: bounds.getSouthWest().lng },
        bounds.getSouthWest(),
        { lat: bounds.getSouthWest().lat, lng: bounds.getNorthEast().lng },
      ]]]));
    }
  }, [bounds, webglLayers]);
};
